import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';
import { ApiError, AsyncThunkConfig } from '../../api/axiosConfig';
import { PretestQuestion } from '../../api/pretestApi';
import { pretestQuestionsURL } from '../../utils/paths';
import { requestWithRetry } from '../../utils/retryRequest';

export const getPretestQuestions = createAsyncThunk<
  PretestQuestion[],
  undefined,
  AsyncThunkConfig
>('pretestQuestions/get', async (_, thunkApi) => {
  try {
    const response = await requestWithRetry<PretestQuestion[]>(
      pretestQuestionsURL
    );

    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response != null) {
      const extractedError = error.response.data as ApiError;

      return thunkApi.rejectWithValue(extractedError);
    }
    throw error;
  }
});
